import * as React from 'react';
import {
    Create,
    TextInput,
    required,
    SimpleForm,
    SelectInput,
    regex,
    useNotify,
    useRedirect,
    useGetList,
} from 'react-admin';
import { BASE_URL, BASE_URL_GO, COUNTRY_CODES, USER_STATUSES } from '../../common/constants';
import FileUpload from '../../common/inputs/FileUpload';
import { MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import {
    validateEmail,
    validateNotEmpty,
    validatePhoneNumber,
} from '../../common/VideoPlayer/util';
import { goApi } from '../../services';

const UserCreate = () => {
    const notify = useNotify();
    const redirect = useRedirect();
    const [role, setRole] = React.useState('');
    const [roleId, setRoleId] = React.useState('');

    const validateNameNoNumbers = regex(/^[A-Za-z\s]+$/, 'Name cannot contain numbers.');

    const capitalizeFirstLetter = (value: string) => {
        if (!value) return value;
        return value.replace(/\b\w/g, char => char.toUpperCase());
    };

    const { data: rolesList = [] } = useGetList<any>('roles', {
        sort: { field: 'watchDate', order: 'ASC' },
        pagination: { page: 1, perPage: 100 },
    });

    const predefinedRoles = [{ name: 'STUDENT', id: '4d8c2d80-a3e9-4d1a-be12-08def4829437' }];

    const roleOptions = [
        ...predefinedRoles,
        ...rolesList.map(role => ({
            name: role.name,
            id: role.id,
        })),
    ];

   const handleSubmit = async (values: any) => {
    try {
        const finalData = {
            ...values,
            role: role,
            roleId: roleId,
        };

        await goApi.post('/users', finalData);

        notify('User created successfully', { type: 'success' });
        redirect('/users');
    } catch (error: any) {
        console.error('Error creating user:', error);
        notify(error?.message || 'Failed to create user', { type: 'warning' });
    }
};

    return (
        <Create>
            <SimpleForm onSubmit={handleSubmit}>
                {/* Role Selection */}
                <FormControl fullWidth required>
                    <InputLabel>Role</InputLabel>
                    <Select
                        value={role}
                        onChange={e => {
                            const selectedRole = roleOptions.find(
                                option => option.name === e.target.value,
                            );
                            setRole(e.target.value);
                            setRoleId(selectedRole?.id || '');
                        }}
                        fullWidth
                    >
                        {roleOptions.map(option => (
                            <MenuItem key={option.id} value={option.name}>
                                {option.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                {/* Other Inputs */}
                <FileUpload type="VIDEO_THUMBNAIL" source="profileImage" accept={'image/*'} />
                <TextInput
                    source="firstName"
                    validate={[required(), validateNameNoNumbers, validateNotEmpty]}
                    format={capitalizeFirstLetter}
                    fullWidth
                />
                <TextInput
                    source="lastName"
                    format={capitalizeFirstLetter}
                    fullWidth
                    validate={[required(), validateNameNoNumbers, validateNotEmpty]}
                />
                <SelectInput source="countryCode" choices={COUNTRY_CODES} fullWidth />
                <TextInput
                    source="phone"
                    validate={[required(), validatePhoneNumber]}
                    fullWidth
                    inputProps={{ maxLength: 10 }}
                    onChange={e => {
                        const onlyNumbers = e.target.value.replace(/\D/g, '');
                        e.target.value = onlyNumbers;
                    }}
                />

                <TextInput source="registrationNumber" fullWidth />
                <TextInput source="email" validate={[required(), validateEmail]} fullWidth />
                <TextInput source="admissionNumber" fullWidth />
                <SelectInput required source="status" choices={USER_STATUSES} fullWidth />
            </SimpleForm>
        </Create>
    );
};

export default UserCreate;
